import { paths as CustomerCommunicationPaths } from '@luxuryescapes/contract-customer-communication';

import { request } from '~/services/common';

import { DestinationAffinityParams, makeDestinationAffinityURL } from './destinationAffinityRequestUtils';

type DestinationAffinityDraftGetContract =
  CustomerCommunicationPaths['/api/customer-communication/v1/custom-schedules/destination-affinity/draft']['get'];
type DestinationAffinityDraftResponse =
  DestinationAffinityDraftGetContract['responses']['200']['content']['application/json'];

/**
 * The draft is custom schedule fields: the hero image and links, then the offer and trending destination sections at
 * their template positions. The header images are absent when the destination has no hero images yet. The options are
 * hero images the team could swap in, best first.
 */
export type DestinationAffinityDraftResult = DestinationAffinityDraftResponse['result'];

/** One of the draft's offer or trending destination sections */
export type DestinationAffinityDraftSection = DestinationAffinityDraftResult['draft']['customSections'][number];

/**
 * The destination's hero image, its offers ranked by margin, and trending destinations. No AI involved.
 */
async function requestGetDestinationAffinityDraft(params: DestinationAffinityParams) {
  const response: DestinationAffinityDraftResponse = await request(
    makeDestinationAffinityURL('/draft', params).toString(),
    { method: 'GET', credentials: 'include' },
  );
  return response.result;
}

export default requestGetDestinationAffinityDraft;
